import { API_BASE } from "../../config/env";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export const FETCH_AGREEMENTS_PENDING = "FETCH_AGREEMENTS_PENDING";
export const FETCH_AGREEMENTS_FULFILLED = "FETCH_AGREEMENTS_FULFILLED";
export const FETCH_AGREEMENTS_REJECTED = "FETCH_AGREEMENTS_REJECTED";

export const FETCH_INITIATE_REGISTER_PENDING =
  "FETCH_INITIATE_REGISTER_PENDING";
export const FETCH_INITIATE_REGISTER_FULFILLED =
  "FETCH_INITIATE_REGISTER_FULFILLED";
export const FETCH_INITIATE_REGISTER_REJECTED =
  "FETCH_INITIATE_REGISTER_REJECTED";

export const FETCH_COMPLETE_REGISTER_PENDING =
  "FETCH_COMPLETE_REGISTER_PENDING";
export const FETCH_COMPLETE_REGISTER_FULFILLED =
  "FETCH_COMPLETE_REGISTER_FULFILLED";
export const FETCH_COMPLETE_REGISTER_REJECTED =
  "FETCH_COMPLETE_REGISTER_REJECTED";

export const RESET_REGISTER = "RESET_REGISTER";

// UUID oluşturma fonksiyonu
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

// Uygulama başladığında `Client-Id` ve `One-Id`'yi ayarla
if (!localStorage.getItem("Client-Id")) {
  localStorage.setItem("Client-Id", uuidv4());
}
if (!localStorage.getItem("One-Id")) {
  localStorage.setItem("One-Id", uuidv4());
}

// Sözleşmeleri Al (Agreement for Register)
export function fetchAgreements(nationality) {
  return (dispatch) => {
    dispatch({ type: FETCH_AGREEMENTS_PENDING });
    return axios
      .get(`${API_BASE}/api/v3/auth/agreement-for-register?nationality=${nationality}`, {
        headers: {
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("Client-Id")
        }
      })
      .then((response) => {
        dispatch({
          type: FETCH_AGREEMENTS_FULFILLED,
          payload: response.data
        });
      })
      .catch((error) => {
        if (error.response?.status === 429) {
          Swal.fire({
            icon: "error",
            title: "Erişim Kısıtlandı",
            text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Bu durum, hesabınızın güvenliği veya sistemimizin düzgün çalışması için alınan bir önlemdir. Lütfen destek ekibimizle iletişime geçin. Anlayışınız için teşekkür ederiz!",
            footer: `
                          <div>
                            <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
                            <br>
                            <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
                            <br>
                            <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
                          </div>
                        `
          });
        }
        dispatch({
          type: FETCH_AGREEMENTS_REJECTED,
          payload: error.response ? error.response.data : error.message
        });
      });
  };
}

// Kayıt Başlatma (Initiate Register)
export function initiateRegister(formData) {
  const { phoneNumber, ...data } = formData;

  localStorage.setItem("phoneNumber", phoneNumber);

  return (dispatch) => {
    dispatch({ type: FETCH_INITIATE_REGISTER_PENDING });
    return axios({
      method: "post",
      url: `${API_BASE}/api/v3/auth/initiate-register`,
      data: { phoneNumber, ...data },
      headers: {
        "Accept-Language": "tr-tr",
        "Client-Id": localStorage.getItem("Client-Id"),
        "One-Id": localStorage.getItem("One-Id"),
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        dispatch({
          type: FETCH_INITIATE_REGISTER_FULFILLED,
          payload: response.data
        });
      })
      .catch((error) => {
        if (error.response?.status === 429) {
          Swal.fire({
            icon: "error",
            title: "Erişim Kısıtlandı",
            text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Bu durum, hesabınızın güvenliği veya sistemimizin düzgün çalışması için alınan bir önlemdir. Lütfen destek ekibimizle iletişime geçin. Anlayışınız için teşekkür ederiz!",
            footer: `
                  <div>
                    <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
                    <br>
                    <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
                    <br>
                    <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
                  </div>
                `
          });
        }
        dispatch({
          type: FETCH_INITIATE_REGISTER_REJECTED,
          payload: error.response ? error.response.data : error.message
        });
      });
  };
}

// Kayıt Tamamlama (Complete Register)
export function completeRegister(phoneNumber, verificationCode) {
  return (dispatch) => {
    dispatch({ type: FETCH_COMPLETE_REGISTER_PENDING });
    return axios({
      method: "post",
      url: `${API_BASE}/api/v3/auth/complete-register`,
      data: { phoneNumber, verificationCode },
      headers: {
        "Accept-Language": "tr-tr",
        "Client-Id": localStorage.getItem("Client-Id"),
        "One-Id": localStorage.getItem("One-Id"),
        "Content-Type": "application/json"
      }
    })
      .then((response) => {
        dispatch({
          type: FETCH_COMPLETE_REGISTER_FULFILLED,
          payload: response.data
        });
      })
      .catch((error) => {
        if (error.response?.status === 429) {
          Swal.fire({
            icon: "error",
            title: "Erişim Kısıtlandı",
            text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Bu durum, hesabınızın güvenliği veya sistemimizin düzgün çalışması için alınan bir önlemdir. Lütfen destek ekibimizle iletişime geçin. Anlayışınız için teşekkür ederiz!",
            footer: `
                  <div>
                    <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
                    <br>
                    <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
                    <br>
                    <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
                  </div>
                `
          });
        }
        dispatch({
          type: FETCH_COMPLETE_REGISTER_REJECTED,
          payload: error.response ? error.response.data : error.message
        });
      });
  };
}

// Reset Register State
export function resetRegister() {
  return (dispatch) => {
    dispatch({
      type: RESET_REGISTER
    });
  };
}
